/*
 * PDP interactions matrix option selectors to narrow down product to purchase
 */
(function ($) {
    const selectors = {
            addOnButton: '#add-compatible-product-button',
            addOnSelectorButton: '#add-compatible-product-selector-button',
            addOnSuccess: '#pdp-add-on-success',
            addOnButtonModalHeader: '#add-on-button-modal-header',
            addOnButtonModalSubheader: '#add-on-button-modal-subheader',
            addOnButtonPackageBucketId: "#pdp-add-on-button-package-bucket-id",
            addToCartButton: "#pdp-add-to-cart",
            addToCartUINotify: ".js-add-to-cart-loading",
            availableToShipDate: ".js-pdp-available-to-ship",
            buildKitExplainerLink: "#built-kit-explainer",
            buyGrid: "#buy-grid",
            buyGridParent: "#pdp-selection-fixed",
            brandName: "#pdp-brand-name",
            canadianOverridePrice: "#pdp-canadian-override-price",
            compatibilityButton: "#btn-compatible-finder",
            componentItemIds: "#pdp-selected-component-item-ids",
            componentItemList: "#pdp-component-item-list",
            coreNodePath: "#pdp-core-node-path",
            coreNodeId: "#pdp-core-node-id",
            countdownHide: ".js-countdown-hide",
            countdownShow: ".js-countdown-show",
            discountMessage: ".js-discount-message",
            displayPanels: ".js-display-panel",
            errorMessage: ".js-selection-error",
            estimatedShipDate: "#pdp-estimated-ship-date",
            findInStoreButton: "#btn-find-in-store",
            giftCardCustomRadio: "#pdp-selection-0",
            giftCardCustomTextBox: "#pdp-giftcard-custom",
            giftCardMaxError: "#gift-card-max-error",
            giftCardMinError: "#gift-card-min-error",
            hazmatId: "#pdp-hazmat-id",
            items: "#pdp-item-list",
            matrices: ".js-selection-matrix",
            matrixOptionList: ".pdp-selection-list",
            matrixOptions: ".js-selection-matrix-option",
            notifyMeButton: "#notify-me-button",
            price: "#price-display",
            productAvailability: "#pdp-product-availability",
            productId: "#pdp-product-id",
            productType: "#hfProductType",
            productSku: "#product-sku",
            productSkuMobile: "#product-sku-mobile",
            secondaryBuyGrid: "#secondary-buy-grid",
            selectedItem: "#pdp-selected-item",
            specAccordian: "#pdp-specs .js-mobile-accordion-header",
            reviewComponent: ".review-component-CategorySnippet",
            pdpReviews: "#pdp-reviews",
            preventFinalSaleReturns: "#pdp-prevent-final-sale-returns",
        },
        $displayPanels = $(selectors.displayPanels),
        productType = $(selectors.productType).val();
    
    let countdownExpired = false;

    //helper method that transforms a number to a currency-formatted string (US dollars only)
    function formatNumberToCurrency(num) {
      return numeral(num).format();
    }

    $(window).on("resize", function () {
      handleBuyGridStick();
    });

    $(window).on("load", function () {
      handleBuyGridStick();
    });

    /**
     * Adjusts the height and alignment of the buy-grid sidebar based on the viewport height and the combined height
     * of the primary and secondary buy grids. This ensures the appropriate display and alignment in varying viewport
     * or content height scenarios.
     * @remarks Has no effect on smaller viewports since these elements are not in a flex-box when the viewport is less
     * than 780px in width.
     * @return {void} Does not return a value. Handles CSS adjustments directly on the DOM elements.
     */
    function handleBuyGridStick() {
      const viewportHeight = $(window).height();
      const buyGridHeight =
        $(selectors.buyGrid).outerHeight() +
        $(selectors.secondaryBuyGrid).outerHeight();
      $(selectors.buyGridParent).css("height", buyGridHeight);

      // Edge-case 1: if the buy-grid sidebar is sticky with flex-start and larger than the screen height, users cannot
      // see the bottom until they scroll all the way down.
      // Edge-case 2: if the sidebar is sticky with flex-end and shorter than the screen height it’s stuck to the
      // bottom of the screen and looks odd.
      if (buyGridHeight < viewportHeight) {
        $(selectors.buyGridParent)
          .css("align-self", "flex-start")
          .css("top", "60px")
          .css("bottom", "auto");
      } else {
        $(selectors.buyGridParent)
          .css("align-self", "flex-end")
          .css("top", "auto")
          .css("bottom", "0");
      }
    }

    //helper method that creates the html needed for the price display in the buy grid
    function createPriceDisplay(
        minPrice,
        minPriceStatus,
        maxPrice,
        maxPriceStatus,
    ) {
        var elements = [];

        elements.push(
            createPriceSpan(
                minPrice,
                minPriceStatus,
                minPriceStatus !== maxPriceStatus || minPrice === maxPrice,
            ),
        );
        if (minPrice < maxPrice) {
            //display a hyphen
            //if either of the prices are full-priced, the hyphen should be black, otherwise red
            elements.push(
                $("<span></span>")
                    .addClass(
                        "pdp-price-" +
                        (minPriceStatus === 1 || maxPriceStatus === 1
                            ? "regular"
                            : "discount") +
                        " pdp-price-display",
                    )
                    .html(" - "),
            );
            elements.push(createPriceSpan(maxPrice, maxPriceStatus, true));
        }

        return elements;
    }

    //helper method that creates the html needed for a price and its price status
    function createPriceSpan(price, priceStatus, includeStatus) {
        var priceClass = priceStatus === 1 ? "regular" : "discount",
            $priceSpan = $("<span></span>").addClass(
                "pdp-price-" + priceClass + " pdp-price-display no-wrap",
            );

        $priceSpan.html(formatNumberToCurrency(price));

        if (includeStatus) {
            switch (priceStatus) {
                case 2:
                    $priceSpan.append(" Sale");
                    break;
                case 3:
                    $priceSpan.append(" Limited Time");
                    break;
                case 4:
                    $priceSpan.append(" Clearance");
                    break;
                case 5:
                    if ($(selectors.preventFinalSaleReturns).val()) {
                        $priceSpan.append(" Final Sale");
                    } else {
                        $priceSpan.append(" Clearance");
                    }
                    break;
            }
        }

        return $priceSpan;
    }

    function calculatePriceStatus(price, marketingPrice) {
        if (marketingPrice <= 0 || price > marketingPrice) {
            return 1;
        }

        var percentSavings = Math.round(
            ((marketingPrice - price) / marketingPrice) * 100,
        );
        if (percentSavings >= 70) {
            return 5;
        } else if (percentSavings >= 60) {
            return 4;
        } else if (percentSavings > 3) {
            return 2;
        } else {
            return 1;
        }
    }

    // function that updates the affirm promotion messaging
    function updateAffirmUI(minPrice, maxPrice) {
        var affirmDisplay = document.getElementById("affirmLearnMore");
        if (!affirmDisplay) {
            return;
        }

        // WX-2323 Fix to prevent iOS users needing to double tap
        // iPads use 'macintosh' agent, so we need to check if it is a
        // mac device as well as a touch device
        var isMacDevice = /iphone|macintosh/i.test(
            window.navigator.userAgent.toLowerCase(),
        );
        var isTouchDevice = window.navigator.maxTouchPoints > 0;

        var displayPrice = minPrice >= 50 ? minPrice : maxPrice;
        var fixedDisplayPrice = (displayPrice * 100).toFixed();

        $(affirmDisplay).attr("data-amount", fixedDisplayPrice);

        affirm.ui.ready(function () {
            if (displayPrice < 50) {
                affirmDisplay.style.display = "none";
            } else {
                affirmDisplay.style.display = "block";
            }

            if (!isMacDevice && !isTouchDevice) {
                affirm.ui.refresh();
            }
        });
    }

    // function to scroll viewport to error messages that is used in the compatability and the Add to cart handler.
    function scrollToErrorMessage(el) {
        var errorOffset = el.getBoundingClientRect().y;

        //55 is the height of the sticky nav
        if (errorOffset < 55) {
            $("html").animate(
                {
                    scrollTop: $(selectors.buyGrid).offset().top,
                },
                300,
            );
        }
    }

    // Determines if a matrix selector needs to be shown before compatible add on products can be shown 
    function showAddOnSelectorModal(selectedItemId) {
        var packageBucketId = $(selectors.addOnButtonPackageBucketId).val();
        var addOnButton = $(selectors.addOnButton);
        var addOnSelectorModalButton = $(selectors.addOnSelectorButton);

        if (!selectedItemId && packageBucketId) {
            addOnButton.hide();
            addOnSelectorModalButton.show();
        } else {
            addOnButton.show();
            addOnSelectorModalButton.hide();
        }
    }

    function buyGridSelection() {
        $(selectors.buyGrid).matrixSelectors({
            items: componentItems || itemInfo,
            selectionUpdated: function (result) {
                //in case we've isolated our selections down to one, update the hidden element needed for the form to post
                var isolatedItemId =
                    result.itemIds.length === 1 ? result.itemIds[0] : "";

                //the item id will never be isolated for mashups, so we need to
                //check if all of the item ids are unique by checking the un-selected matrices.
                if (productType === "Mashup") {
                    var mashupItem = null;
                    // For mashups, there is only ever 1 or 0 items on itemInfo
                    $.each(itemInfo, function (itemId, item) {
                        mashupItem = item;
                    });

                    if (!mashupItem) return;

                    result.displayType = mashupItem.DisplayType;
                    result.isInCollection = false;
                    result.minPrice = mashupItem.Price;
                    result.maxPrice = mashupItem.Price;

                    //since limited time trumps and we have no way of calculating it here (no retail price available)
                    //just keep limited time if the status is already so
                    if (result.minPriceStatus !== 3) {
                        result.minPriceStatus = calculatePriceStatus(
                            result.minPrice,
                            result.minMarketingPrice,
                        );
                    }
                    if (result.maxPriceStatus !== 3) {
                        result.maxPriceStatus = calculatePriceStatus(
                            result.maxPrice,
                            result.maxMarketingPrice,
                        );
                    }

                    //we can consider a mashup selected only if all the matrices have a checked option
                    //or if they only have one enabled option
                    //when this is true, we can set the isolated item id to the mashup item id
                    isolatedItemId = $(selectors.matrices)
                        .not(":has(" + selectors.matrixOptions + ":checked)")
                        .not(function (i, matrix) {
                            return (
                                $(matrix)
                                    .find(selectors.matrixOptions + ":enabled")
                                    .size() === 1
                            );
                        })
                        .size()
                        ? ""
                        : mashupItem.ItemId;

                    $(selectors.componentItemIds).val(result.itemIds.join(","));
                }

                // This handler fires on matrix option mouseover and change (click) events. Items should only be considered 'selected' when matrix options were clicked such that there
                // is only one possible item for the selected matrix option combination
                const selectedItem =
                    isolatedItemId && result.eventType === "change"
                        ? itemInfo[isolatedItemId]
                        : null;

                // replace parent SKU with child SKU
                if (selectedItem && selectedItem.SKU) {
                    // All SKU values in the database either have a EB- or MU- pre-appended. We don't want to show these to the customer,
                    // just the numeric values followed by the dash. If the modified SKU does not match the expected value then just don't show it.
                    const modifiedSKU = selectedItem.SKU.substring(3);
                    const pattern = /^\d+-\d+$/;
                    if (pattern.test(modifiedSKU)) {
                        $(selectors.productSku).html("sku# " + modifiedSKU);
                        $(selectors.productSkuMobile).html("sku# " + modifiedSKU);
                    } else {
                        console.warn("Invalid SKU#: " + modifiedSKU);
                    }
                }

                // Only send datalayer event if the selected item has changed
                // For mashups, the parent SKU never changes. Only send datalayer event if price of mashup changes
                if (
                    selectedItem &&
                    (selectedItem.SKU !== dataLayerProduct.dimension1 ||
                        selectedItem.Price !== dataLayerProduct.price)
                ) {
                    dataLayerProduct.dimension1 = selectedItem.SKU;
                    dataLayerProduct.price = selectedItem.Price;
                    dataLayerProduct.variant = selectedItem.Color;
                    dataLayerProduct.availability = selectedItem.Availability;
                    dataLayerProduct.marketingPrice = selectedItem.MarketingPriceRange;
                    dataLayerProduct.selloutRisk = selectedItem.SelloutRisk;
                    dataLayerProduct.priceStatus = selectedItem.PriceStatus;
                    dataLayerProduct.imageUrl = selectedItem.ImageUrl;
                    window.dataLayerManager.pushDetailView(dataLayerProduct);
                    window.childSku = selectedItem.SKU;
                }

                //update the page display
                $(selectors.price)
                    .css("visibility", "visible")
                    .html(
                        createPriceDisplay(
                            result.minPrice,
                            result.minPriceStatus,
                            result.maxPrice,
                            result.maxPriceStatus,
                        ),
                    );

                //if both the min and max prices are not full-priced, we need to show the original price
                if (result.minPriceStatus !== 1 && result.maxPriceStatus !== 1) {
                    var origPriceDisplay = $("<span></span>").addClass(
                        "pdp-price-message-group",
                    );
                    origPriceDisplay.append("Orig: ");
                    origPriceDisplay.append(
                        formatNumberToCurrency(result.minMarketingPrice),
                    );
                    if (result.minMarketingPrice < result.maxMarketingPrice) {
                        origPriceDisplay.append(
                            " - " + formatNumberToCurrency(result.maxMarketingPrice),
                        );
                    }
                    $(selectors.price).append(origPriceDisplay);
                }

                $(selectors.selectedItem).val(isolatedItemId);

                //update the display panels that vary based on what is selected/available
                var displayPanelsToShow =
                    ".js-availability-" +
                    result.availability +
                    ",.js-display-type-" +
                    result.displayType +
                    ",.js-display-type-" +
                    result.displayType +
                    "-availability-" +
                    result.availability;

                var compatibilityButton = $(selectors.compatibilityButton);

                //also if we're narrowed down, we need to update the sell out risk display
                if (isolatedItemId) {
                    displayPanelsToShow +=
                        ",.sellout-risk-" + itemInfo[isolatedItemId].SelloutRisk;

                    if ($(selectors.preventFinalSaleReturns).val()) {
                        // Show final sale messaging for any item 70% off or more, including temp markdowns
                        if (isolatedItemId && calculatePriceStatus(itemInfo[isolatedItemId].Price, itemInfo[isolatedItemId].MarketingPrice) == 5) {
                            var finalSaleMessageDisplay = $("<span></span>").addClass(
                                "pdp-price-final-sale-message",
                            );
                            finalSaleMessageDisplay.append("This item is final sale and cannot be returned or exchanged.");
                            $(selectors.price).append(finalSaleMessageDisplay);
                        }
                    }
                }

                //disable the compatibility button if we're isolated down to item(s) that are not available at the warehouse,
                //are not display type of full, or do not belong to collection(s)
                compatibilityButton.prop(
                    "disabled",
                    !!(
                        !result.isInCollection ||
                        (result.availability & 1) !== 1 ||
                        result.displayType !== 1
                    ),
                );

                showAddOnSelectorModal(isolatedItemId);

                $displayPanels.not(displayPanelsToShow).hide();
                $displayPanels.filter(displayPanelsToShow).show();

                const estimatedShipDate = result.estimatedShipDate;
                const shippingTimeMessaging = estimatedShipDate
                    ? "Estimated ship date: " +
                    `${
                        estimatedShipDate.getUTCMonth() + 1
                    }/${estimatedShipDate.getUTCDate()}/${estimatedShipDate
                        .getUTCFullYear()
                        .toString()
                        .substring(2)}`
                    : "Ships in 24 Hours";

                $(selectors.availableToShipDate).html(shippingTimeMessaging);

                if (estimatedShipDate || countdownExpired) {
                    $(selectors.countdownHide).show();
                    $(selectors.countdownShow).hide();
                } else if (!countdownExpired) {
                    $(selectors.countdownShow).show();
                    $(selectors.countdownHide).hide();
                }

                updateAffirmUI(result.minPrice, result.maxPrice);
            },
        });
    }

    buyGridSelection();
    /*
     * mobile reviews click.
     * since the reviews are hidden at mobile we need to hjiack the functionality
     * of the click event on the stars and scroll and open the accordion
     */

    $(selectors.reviewComponent).on("click", function (e) {
        if (evo.isMobile) {
            $("body, html").animate(
                {
                    scrollTop: $(selectors.pdpReviews).offset().top,
                },
                500,
                "swing",
                function () {
                    var $reviewsAccordionHeader = $(
                        selectors.pdpReviews + " .js-mobile-accordion-header",
                    );
                    if (!$reviewsAccordionHeader.hasClass("active")) {
                        $reviewsAccordionHeader.trigger("click");
                    }
                },
            );
        }
    });

    //handle for the compatibility button click
    //simply redirects the user to the href attribute
    //(anchor tag wasn't used here since they can't be disabled)
    $(selectors.compatibilityButton)
        .on("click", function (e) {
            e.preventDefault();
            var selectedItemId = $(selectors.selectedItem).val(),
                $this = $(this);

            if (selectedItemId) {
                window.location.href =
                    $this.data("href-base") + "&SelectedItemIds=" + selectedItemId;
            }
        });

    // Since the custom gift card amount is a textbox, but all the other
    // values of the gift card are radio buttons, need to assign the number
    // entered into the text box to its associated radio button.
    (function () {
        var customRadio = $(selectors.giftCardCustomRadio);

        // If the product is not gift card then exit the function
        if (!customRadio.size()) {
            return false;
        }

        //load default item ids for the custom radio button (it has none by default)
        var allItemIds = Object.keys(itemInfo);
        customRadio.attr("data-itemids", allItemIds.join(","));
        customRadio.addClass("_" + allItemIds.join(" _"));

        //also clear out the value of the radio (default is 'on' for some reason)
        customRadio.val("");

        // Prevent non-numeric values from being entered for the custom amount
        $(selectors.giftCardCustomTextBox)
            .keydown(function (event) {
                switch (event.which) {
                    //backspace
                    case 8:
                    //tab
                    case 9:
                        return true;
                    //delete
                    case 46:
                    //arrow keys
                    case 37:
                    case 38:
                    case 39:
                    case 40:
                    //home/end
                    case 35:
                    case 36:
                        return true;
                    //case 0-9
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                        var indexOfPeriod = this.value.indexOf(".");
                        return (
                            indexOfPeriod === -1 || indexOfPeriod > this.value.length - 3
                        );
                    //'.' period
                    case 110:
                    case 190:
                        return this.value.indexOf(".") < 0;
                    default:
                        return false;
                }
            })
            .on("focus keyup", function () {
                // On keyup update the value for the radio button based on what has been entered in the text box.
                const amount = $(this).val().trim();

                customRadio.prop("checked", !!amount);
                customRadio.val(amount);
                customRadio.data(
                    "display-value",
                    isNaN(amount) ? "" : formatNumberToCurrency(amount),
                );
                customRadio.trigger("change");

                // gift card amount cannot be greater than 1000
                $(this)
                    .parent()
                    .siblings(selectors.giftCardMaxError)
                    .toggle(amount > 1000);

                // gift card amount cannot be less than 20
                $(this)
                    .parent()
                    .siblings(selectors.giftCardMinError)
                    .toggle(!!amount && amount < 20);
            })
            .on("mouseup", function (event) {
                event.stopImmediatePropagation();
            });
    })();

    $(selectors.addOnSelectorButton).on('click', function (clickEvent) {
        clickEvent.preventDefault();

        const selectorModalAction = this.attributes.getNamedItem("data-addon-selector-action").value;
        let $loadingFeedback = $(selectors.addToCartUINotify);
        $loadingFeedback.addClass("loading");

        const $dynamicModal = generateModalTemplate("", "modal-loading pdp-interstitial");

        $.get(selectorModalAction)
            .done((result) => {
                $dynamicModal.find(".modal-content").append(result);
                evo.$.body.trigger("loaded.evo.pdp.interstitial", $dynamicModal);
            })
            .fail(function () {
                $dynamicModal.modal("hide");
            })
            .always(function () {
                $dynamicModal.removeClass("modal-loading");
                $loadingFeedback.removeClass("loading");
            });

    })
    $(selectors.addOnButton).on('click', function (e) {
        e.preventDefault();
        
        const action = this.attributes.getNamedItem("data-compatible-related-products-action").value;
        const selectedItemId = $(selectors.selectedItem).val();
        const updatedItemIdAction = action.replace(/ItemId=\d+/, "ItemId=" + selectedItemId);
        const productName = this.attributes.getNamedItem("data-product-name").value;
        const modalHeader = $(selectors.addOnButtonModalHeader).val();
        const modalSubheader = $(selectors.addOnButtonModalSubheader).val();
        
        window.dataLayerManager.pushCompatibleBindingsClick(productName);
        let $loadingFeedback = $(selectors.addToCartUINotify);
        $loadingFeedback.addClass("loading");
        
        const $dynamicModal = generateModalTemplate("", "modal-loading pdp-interstitial");

        $.get(updatedItemIdAction)
            .done((result) => {
                $dynamicModal.find(".modal-content").append(result);
                $dynamicModal.find(".add-on-header").append(modalHeader);
                $dynamicModal.find(".add-on-subheader").append(modalSubheader);
                evo.$.body.trigger("loaded.evo.pdp.interstitial", $dynamicModal);
            })
            .fail(function () {
                $dynamicModal.modal("hide");
                window.alert("Oops! An error occurred while loading compatible products, please refresh the page and try again.");
            })
            .always(function () {
                $dynamicModal.removeClass("modal-loading");
                $loadingFeedback.removeClass("loading");
            });
    })

    // The handler for the add to cart click event.
    // Asserts that the user has narrowed the selections down to a single SKU
    // if not, it prevents the user from continuing and displays validation messages.
    // If valid will display the interstitial cart modal for the customer.
    $(selectors.addToCartButton).on("click", function (e) {
        e.preventDefault();

        var selectedItemId = $(selectors.selectedItem).val(),
            $loadingFeedback = $(selectors.addToCartUINotify);

        var skusByItemIds = JSON.parse($(selectors.items).val());
        var customComponentItems = JSON.parse($(selectors.componentItemList).val());

        // Price does not work quite the same as the other matrix selectors because the value of price is not a ProductID.
        var prices = $('input[name="Price"]');
        var selectedPrice = prices.filter(":checked");
        var quantity = $("#pdp-add-to-cart-qty").val();
        var hazmatId = $('input[name="HazardousMaterialId"]').val();

        if (selectedItemId) {
            if (
                !prices.length ||
                (selectedPrice.length &&
                    !isNaN(selectedPrice.val()) &&
                    parseFloat(selectedPrice.val()) > 0)
            ) {
                var $this = $(this);

                // UI add loading class to button
                $loadingFeedback.addClass("loading");

                // Add selected item to the cart
                var $form = $this.closest("form");
                var addToCartAction = $form.attr("action");
                var json = {
                    AddOnInCart: $(selectors.addOnSuccess).val(),
                    Availability: $(selectors.productAvailability).val(),
                    BrandName: $(selectors.brandName).val(),
                    CanadianOverridePrice: $(selectors.canadianOverridePrice).val(),
                    CoreTaxonomyNodePath: $(selectors.coreNodePath).val(),
                    EstimatedShipDate: $(selectors.estimatedShipDate).val(),
                    ItemId: selectedItemId,
                    ProductId: $(selectors.productId).val(),
                    CoreTaxonomyNodeId: $(selectors.coreNodeId).val(),
                    Quantity: quantity,
                    SKU: skusByItemIds[selectedItemId],
                };
                
                if (hazmatId > 0) {
                    json["HazardousMaterialId"] = hazmatId;
                }

                if (selectedPrice.length) {
                    json["Price"] = selectedPrice.val();
                    json["To"] = $('input[name="To"]').val();
                    json["From"] = $('input[name="From"]').val();
                    json["EmailAddress"] = $('input[name="EmailAddress"]:visible').val();
                    json["Message"] = $('input[name="Message"]').val();
                    json["Option"] = $('input[name="Option"]:enabled').val();
                } else {
                    var componentItemIds = $(selectors.componentItemIds).val();
                    if (componentItemIds.length) {
                        var groupedComponentIds = componentItemIds.split(",");
                        json["ComponentItemIds"] = groupedComponentIds;

                        json["ComponentItems"] = [];
                        for (var i = 0; i < groupedComponentIds.length; i++) {
                            var mashupComponentItem = customComponentItems.filter((item) =>
                                item["ItemId"].toString().includes(groupedComponentIds[i]),
                            );
                            json["ComponentItems"].push(
                                JSON.stringify(mashupComponentItem[0]),
                            );
                        }
                    }
                }

                $.get(addToCartAction, $.param(json, true))
                    .done(function (result) {
                        if (!result.success) {
                            $loadingFeedback.removeClass("loading");

                            $.each(result.errors, function () {
                                var $validationMessages = $(
                                    '[data-val-message-for="' + this.property + '"]',
                                );

                                $validationMessages.html(this.errors[0]).show();
                                $('input[name="' + this.property + '"]').one(
                                    "change",
                                    function () {
                                        $validationMessages.hide();
                                    },
                                );
                            });

                            return;
                        }
                        
                        // Request the interstitial cart view
                        $.ajax($this.data("interstitial-action"), {
                            data: $.param(json, true),
                            cache: false,
                            method: "get",
                        })
                            .done(function (html) {
                                // Place HTML into a modal template
                                const $dynamicModal = generateModalTemplate(
                                  html,
                                  "hidden pdp-interstitial"
                                )
                                evo.$.body.trigger(
                                    "loaded.evo.pdp.interstitial",
                                    $dynamicModal,
                                );
                                $dynamicModal.removeClass('hidden')
                            })
                            .always(function () {
                                $loadingFeedback.removeClass("loading");
                            });
                    })
                    .fail(function () {
                        $("[id^=GiftCard]").each(function () {
                            $(this)
                                .next(selectors.errorMessage)
                                .toggle(
                                    (this.required && !this.value) ||
                                    !this.value.match(
                                        /^[A-Za-z0-9\s\.!#\$%&\*\(\)\?/'"";:\[\]\{\}=\+-_]*$/,
                                    )
                                        ? true
                                        : false,
                                );
                        });
                        $loadingFeedback.removeClass("loading");
                    });
                evo.$.body.trigger("added.evo.pdp.addtocart", selectedItemId);
                return;
            }
        }

        // This is to test for the case of a gift card custom amount being selected, but no value or 0 being entered.
        if (
            prices.length &&
            (!selectedPrice.length ||
                isNaN(selectedPrice.val()) ||
                !parseFloat(selectedPrice.val()) > 0)
        ) {
            prices.prop("checked", false);
        }

        $(selectors.matrices)
            .filter(function () {
                var checkedCount = 0,
                    enabledCount = 0;

                $(this)
                    .find(selectors.matrixOptions)
                    .each(function () {
                        var $opt = $(this);

                        if ($opt.is(":enabled")) {
                            enabledCount++;
                            if ($opt.is(":checked")) {
                                checkedCount++;
                            }
                        }
                    });

                return !checkedCount && enabledCount > 1;
            })
            .find(selectors.errorMessage)
            .each(function (n) {
                var $this = $(this);
                evo.$.body.trigger("error.evo.pdp.addtocart", $this.text());
                $this.show();

                // scroll to the first error message if it is off canvas
                if (n === 0) {
                    scrollToErrorMessage(this);
                }
            });

        $("[id^=GiftCard]").each(function () {
            $(this)
                .next(selectors.errorMessage)
                .toggle(
                    (this.required && !this.value) ||
                    !this.value.match(
                        /^[A-Za-z0-9\s\.!#\$%&\*\(\)\?/'"";:\[\]\{\}=\+-_]*$/,
                    )
                        ? true
                        : false,
                );
        });
    });

    // Prevent the item quantity from being set outside the range [1, 99]
    $(document.body).on("change", 'input[name="Quantity"]', function () {
        var val = $(this).val();
        if (val <= 0) {
            val = 1;
        } else if (val >= 100) {
            val = 99;
        }
        $(this).val(val);
    });

    // Add focus style to matrix option container on tab over
    $(selectors.matrixOptions)
        .on("keyup", function (e) {
            switch (e.keyCode) {
                // tab
                case 9:
                // arrow keys
                case 37:
                case 38:
                case 39:
                case 40:
                    $(this).closest(selectors.matrixOptionList).addClass("focused");
                    break;
                default:
                    return;
            }
        })
        .on("blur", function () {
            $(this).closest(selectors.matrixOptionList).removeClass("focused");
        });

    //click handler for the "Find in Store" button
    //includes the currently selected item id (if any) into the url
    //so that the item can be auto-selected
    $(selectors.findInStoreButton).on("click", function () {
        var $this = $(this),
            selectedItemId = $(selectors.selectedItem).val(),
            href = $this.data("href"),
            originalHref = $this.data("original-href") || href;

        //save the originally set href value so that we can alter it in case
        //the button is clicked multiple times with different selections (corner case)
        $this.data("original-href", originalHref);

        if (selectedItemId) {
            href = originalHref + "&SelectedItemId=" + selectedItemId;
        } else if (href !== originalHref) {
            href = originalHref;
        }
        $this.data("href", href);
    });

    // click handler for the 'Notify Me' button
    $(selectors.notifyMeButton).on("click", function (event) {
        event.preventDefault();

        const action = this.attributes.getNamedItem('data-view-oos-action').value;
        const productName = this.attributes.getNamedItem('data-oos-product-name').value;

        const $dynamicModal = generateModalTemplate("", "modal-loading oos-modal");
        $.get(action)
            .done((result) => {
                $dynamicModal.find(".modal-content").append(result);
                $dynamicModal.find(".modal-header").append(productName);
            })
            .fail(function () {
                $dynamicModal.modal("hide");
            })
            .always(function () {
                $dynamicModal.removeClass("modal-loading");
            });
    });

    //Scroll to build kit spec table when explainer link clicked
    $(selectors.buildKitExplainerLink).on("click", function(event) {
        event.preventDefault();
        const explainerLink = document.querySelector(selectors.buildKitExplainerLink).getAttribute("href");
        if ($(selectors.specAccordian).hasClass("active")) {
            document.querySelector(explainerLink).scrollIntoView({behavior:"smooth"});
        }
        else {
            document.querySelector(selectors.specAccordian).click();
            //Use timeout to wait for accordian open animation
            setTimeout(function(){
                document.querySelector(explainerLink).scrollIntoView({behavior:"smooth"});
            },300);
        }
    });

    evo.$.body.on("time-elapsed.evo.countdown", function () {
        countdownExpired = true;
        $(selectors.countdownHide).show().removeClass("js-countdown-hide");
        $(selectors.countdownShow).remove();
    });
})(jQuery);
